module.exports = __webpack_public_path__ + "static/joyful_2-23220b4cef62e8a7cd27e79bf9cc86b3.jpg";